export default "__VITE_ASSET__COFqJ$Wf__"